var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{directives:[{name:"show",rawName:"v-show",value:(_vm.breadcrumbs.show),expression:"breadcrumbs.show"}],staticClass:"pl-0",attrs:{"divider":"/","items":_vm.crumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"exact":"","to":item.to}},[_c('small',{domProps:{"textContent":_vm._s(item.text)}})])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }